import type { ProjectState } from "hooks/useProjects/useProjects.types";
import type { ParsedProjectPermissions } from "./parseProjectPermissions";

/**
 * Parses permissions from transformed project detail (useProject select output).
 * Fallback when raw cache parsing fails but the detail query already transformed embed data.
 */
export const parseProjectPermissionsFromState = (
  project: ProjectState | null | undefined
): ParsedProjectPermissions | null => {
  const embed = project?.permissions;
  if (!embed?.permissions?.length) {
    return null;
  }

  const projectInfo = embed.projectInfo;
  const roles = embed.roles;

  return {
    permissions: embed.permissions,
    workspaceId: project?.workspaceId ? String(project.workspaceId) : null,
    projectRole: roles?.projectRole ?? null,
    workspaceRole: roles?.workspaceRole ?? null,
    projectInfo: {
      isLicensed: projectInfo?.isLicensed ?? true,
      isTrialProject: projectInfo?.isTrialProject ?? false,
      freeLicensePremiumLocked: projectInfo?.freeLicensePremiumLocked ?? false,
      unlicensedMaxDraftScenes: projectInfo?.unlicensedMaxDraftScenes,
      createSource: projectInfo?.createSource,
    },
  };
};
